const user = {
  state: {
    isShowHeaderBg: false,  // 顶部菜单显示白色背景
    languageType: 1, // 默认中文，1--中文，2--英语，3--韩语
    isPermanentShowHeaderBg: false, // 是否常驻显示背景
  },
  mutations: {
    SET_ISSHOWHEADERBG: (state, isShowHeaderBg)=>{
      state.isShowHeaderBg=isShowHeaderBg
    },
    SET_LANGUAGETYPE: (state, languageType)=>{
      state.languageType=languageType
    },
    SET_ISPERMANENTSHOWHEADERBG: (state, isPermanentShowHeaderBg)=>{
      state.isPermanentShowHeaderBg=isPermanentShowHeaderBg
    },
  },
}

export default user